import addMount from "../../../core/addMount";
import MaterialGridAutomaticEntry from "./MaterialGridAutomatic.entry";

addMount({
  appName: "material-grid-automatic",
  app: MaterialGridAutomaticEntry
});
